import React from 'react'
import { IMAGES } from '../../utils/images'

const DashboardCertificates = () => {
  return (
    <div className="dashboard-content">
    <div className="home-heading-container">
      <h1 className="heading-text-h1">Your Certificates</h1>
 
    </div>
    <hr className="dashboard-home-hr" />
    <div className="dash-courses-card">
        <img src={IMAGES.DASHBOARD_CERTIFICATE} alt="certificate"/>
        <div className="course-bottom">
          <h2 className="course-heading">Javascript Training Completion</h2>
         
        </div>
    </div>
    </div>
  )
}

export default DashboardCertificates